import React, { ReactElement } from 'react';

// Phill's Slack avatar redrawn on lucide's grid — 24px box, 2px strokes, round caps, currentColor —
// so it reads as one of the icon set rather than as pasted-in artwork. Same robot in both places:
// the one that messages you in Slack is the one on the button that turns it on.
export const PhilBotIcon = ({ className }: { className?: string }): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <rect x="4" y="8" width="16" height="10" rx="4" />
    <path d="M4 11.5a1.5 1.5 0 0 0 0 3" />
    <path d="M20 11.5a1.5 1.5 0 0 1 0 3" />
    <path d="m10.2 8 1-3.2" />
    <path d="m13.8 8 1-3.2" />
    <circle cx="9.6" cy="13" r="1.1" fill="currentColor" />
    <circle cx="14.4" cy="13" r="1.1" fill="currentColor" />
  </svg>
);

export default PhilBotIcon;
